(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.getElementById('BrandDrawer');
  if (!drawer) return;
  var panel = drawer.querySelector('.brand-drawer__panel');
  var opens = document.querySelectorAll('[data-brand-drawer-open]');
  var closes = drawer.querySelectorAll('[data-brand-drawer-close]');
  var vehiclesUrl = drawer.dataset.vehiclesUrl;
  var vehicleData = null;
  var selected = { brand: null, brandSlug: null, brandLogoSrc: null, displacement: null, model: null };

  var BRAND_KEEP_CAPS = new Set(['BMW', 'KTM', 'SYM', 'MV', 'GASGAS', 'CF']);
  function formatBrand(name) {
    if (!name) return '';
    return name.split(/\s+/).map(function (word) {
      if (BRAND_KEEP_CAPS.has(word.toUpperCase())) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }
  function displacementOrder(d) {
    if (!d) return 999;
    if (/^bis\s/i.test(d)) { var m = d.match(/(\d+)/); return m ? parseInt(m[1], 10) - 1000 : -999; }
    if (/^über\s/i.test(d) || /^ueber\s/i.test(d)) { var m = d.match(/(\d+)/); return m ? parseInt(m[1], 10) + 10000 : 99999; }
    var m2 = d.match(/(\d+)\s*-\s*(\d+)/); if (m2) return parseInt(m2[1], 10); return 999;
  }
  function bikeIcon() {
    return '<span class="brand-drawer__item-icon"><svg width="22" height="22" viewBox="0 0 128 128" fill="currentColor" aria-hidden="true"><path d="m99.09 69 27.57-9.67a2 2 0 0 0 1.34-1.93c0-1.76-.75-4.34-4.33-6.73-6.87-4.57-21.07-6.2-25.11-4.52-.24.11-12.9 12.85-12.9 12.85h-13l-5.09-6c-1.71-2-7.91-8.66-15.41-8.66h-10c-3.45 0-5.36 2-7 3.67a12.54 12.54 0 0 1 -3 2.48l-2.95-.12a21.45 21.45 0 0 1 8.64-9.9 3.6 3.6 0 0 0 -1.37-6.65c-3.23-.43-7.9-.58-11.8 1.17a41.11 41.11 0 0 0 -18.25 20.7c-.29.71-1.8 4.77 0 7a7.09 7.09 0 0 0 3.95 2.78s14.62 3.06 15.06 3.19l-.54 1.94a21.18 21.18 0 1 0 3.85 1.08l.46-1.68a24 24 0 0 1 13.23 15.9l3.37 13.1a2 2 0 0 0 1.94 1.5h31.75a2 2 0 0 0 1.94-1.5l1.39-5.57h3a21.16 21.16 0 1 0 0-4h-2l.84-3.34a25.62 25.62 0 0 1 14.42-17.09zm7.75 20.46h-9.15a9.37 9.37 0 1 1 0 4h9.15a2 2 0 0 0 0-4zm0 15.37a13.38 13.38 0 1 0 -13.21-15.42h-3.82a17.15 17.15 0 1 1 0 4h3.82a13.4 13.4 0 0 0 13.21 11.37zm-64.71-56.5h10c4.6 0 9.4 3.75 12.36 7.25l5.68 6.71a2 2 0 0 0 1.53.71h14.8a2 2 0 0 0 1.42-.59l12.51-12.67c3.14-.87 15.06.29 21 4.26a6.74 6.74 0 0 1 2.17 2.11s-28.26 10.2-29.3 10.82h-36.53s-1.77-3.61-1.77-3.68a28.19 28.19 0 0 0 -18.27-12.25c.07 0 2.71-2.67 4.4-2.67zm-30.78 13.26s-1.07-.64-1.54-1c-1.68-1.27.87-4.67 1.15-5.28a4.38 4.38 0 0 1 2.28 2.41c.22 1.01-.45 2.37-1.89 3.87zm14.2 21.54a9.37 9.37 0 1 1 -4.39-1.13h.54l-2.47 8.81a2 2 0 0 0 1.39 2.46 2 2 0 0 0 2.46-1.39zm12.76 8.28a17.16 17.16 0 1 1 -17.15-17.16 16.75 16.75 0 0 1 2.66.23l-1 3.66a14.55 14.55 0 0 0 -1.66-.14 13.41 13.41 0 1 0 5.48 1.19l1-3.68a17.17 17.17 0 0 1 10.67 15.9zm39.63 5.09h-28.64l-3-11.6a27.94 27.94 0 0 0 -21.5-20.51l-9.06-1.88a7.12 7.12 0 0 0 1.39-5.66 8.17 8.17 0 0 0 -4.28-5.06 37.37 37.37 0 0 1 13.47-13.19 17.42 17.42 0 0 1 8.44-1 25.42 25.42 0 0 0 -9.5 11.68 3.66 3.66 0 0 0 3.25 5l4.22.16a24.2 24.2 0 0 1 19.82 10.89s9.3 19.19 9.35 19.26a11.39 11.39 0 0 0 9.51 5.15h8.21zm2.68-10.73h-9.2a7.42 7.42 0 0 1 -6.11-3.24l-5.6-11.57h29.36c-4.76 3.29-8.45 14.81-8.45 14.81z"/></svg></span>';
  }
  function arrowIcon() {
    return '<svg class="brand-drawer__item-arrow" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M5 2l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  var STEP_ORDER = ['brands', 'displacement', 'model', 'year'];
  function showStep(name) {
    var loading = drawer.querySelector('[data-step="loading"]');
    if (name === 'loading') {
      if (loading) {
        loading.hidden = false;
        loading.classList.add('brand-drawer__step--active');
      }
      return;
    }
    if (loading) {
      loading.hidden = true;
      loading.classList.remove('brand-drawer__step--active', 'brand-drawer__step--prev');
    }
    var targetIdx = STEP_ORDER.indexOf(name);
    STEP_ORDER.forEach(function (s, i) {
      var el = drawer.querySelector('[data-step="' + s + '"]');
      if (!el) return;
      el.classList.remove('brand-drawer__step--active', 'brand-drawer__step--prev');
      if (i < targetIdx) el.classList.add('brand-drawer__step--prev');
      else if (i === targetIdx) el.classList.add('brand-drawer__step--active');
    });
  }

  async function loadVehicles() {
    if (vehicleData) return vehicleData;
    showStep('loading');
    try {
      var res = await fetch(vehiclesUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      vehicleData = await res.json();
      return vehicleData;
    } catch (e) {
      console.error('[brand-drawer]', e);
      return null;
    }
  }

  function buildCrumb(step) {
    var node = drawer.querySelector('[data-crumb="' + step + '"]');
    if (!node) return;
    var parts = [];
    if (selected.brandLogoSrc) parts.push('<img src="' + selected.brandLogoSrc + '" alt="">');
    if (selected.brand) parts.push('<span>' + selected.brand + '</span>');
    if (step !== 'displacement' && selected.displacement) {
      parts.push('<span class="brand-drawer__crumb-sep">·</span><span>' + selected.displacement + ' ccm</span>');
    }
    if (step === 'year' && selected.model) {
      parts.push('<span class="brand-drawer__crumb-sep">·</span><span>' + selected.model + '</span>');
    }
    node.innerHTML = parts.join('');
  }

  function renderItems(step, items) {
    var ul = drawer.querySelector('[data-list="' + step + '"]');
    if (!ul) return;
    ul.innerHTML = items.map(function (it) {
      return '<li><button type="button" class="brand-drawer__item" data-pick="' + step + '" data-value="' + encodeURIComponent(it.value) + '"' + (it.handle ? ' data-handle="' + it.handle + '"' : '') + (it.gid ? ' data-gid="' + it.gid + '"' : '') + '>' + bikeIcon() + '<span class="brand-drawer__item-label">' + it.label + '</span>' + arrowIcon() + '</button></li>';
    }).join('');
  }

  async function pickBrand(brandLabel, logoSrc) {
    selected.brand = brandLabel;
    selected.brandLogoSrc = logoSrc;
    selected.displacement = null;
    selected.model = null;

    var data = await loadVehicles();
    if (!data) return;
    var normalizedTarget = brandLabel.toUpperCase();
    var brandKey = (data.brands || []).find(function (b) { return formatBrand(b).toUpperCase() === normalizedTarget || b.toUpperCase() === normalizedTarget; });
    if (!brandKey) {
      showStep('displacement');
      buildCrumb('displacement');
      renderItems('displacement', []);
      drawer.querySelector('[data-empty="displacement"]').hidden = false;
      return;
    }
    selected.brandSlug = brandKey;

    var disps = [...new Set((data.vehicles || []).filter(function (v) { return v.brand === brandKey && v.displacement; }).map(function (v) { return v.displacement; }))];
    disps.sort(function (a, b) { return displacementOrder(a) - displacementOrder(b); });

    showStep('displacement');
    buildCrumb('displacement');
    if (!disps.length) {
      renderItems('displacement', []);
      drawer.querySelector('[data-empty="displacement"]').hidden = false;
    } else {
      drawer.querySelector('[data-empty="displacement"]').hidden = true;
      renderItems('displacement', disps.map(function (d) { return { value: d, label: d + ' ccm' }; }));
    }
  }

  function pickDisplacement(disp) {
    selected.displacement = disp;
    selected.model = null;
    var models = [...new Set((vehicleData.vehicles || []).filter(function (v) {
      return v.brand === selected.brandSlug && v.displacement === disp;
    }).map(function (v) { return v.model; }))];
    models.sort(function (a, b) { return a.localeCompare(b, 'de'); });

    showStep('model');
    buildCrumb('model');
    renderItems('model', models.map(function (m) { return { value: m, label: m }; }));
  }

  function pickModel(model) {
    selected.model = model;
    var matches = (vehicleData.vehicles || []).filter(function (v) {
      return v.brand === selected.brandSlug && v.displacement === selected.displacement && v.model === model;
    }).sort(function (a, b) { return a.year_from - b.year_from; });

    showStep('year');
    buildCrumb('year');
    renderItems('year', matches.map(function (v) {
      var range = v.year_to && v.year_to !== v.year_from ? v.year_from + '–' + v.year_to : '' + v.year_from;
      return { value: range, label: range, handle: v.handle, gid: v.gid };
    }));
  }

  function pickYear(gid) {
    if (!gid) return;
    /* Fahrzeug im selben Format ablegen wie die Fahrzeugsuche (Key
       'tsstec.vehicle'). Ohne das kennt die Zielseite die Auswahl nicht:
       weder die "Mein Motorrad"-Leiste noch die Hero-Überschrift noch die
       Fitment-Markierung auf der PDP lesen die URL, alle lesen den Storage. */
    var vehicle = (vehicleData.vehicles || []).filter(function (v) { return v.gid === gid; })[0];
    if (vehicle) {
      try { localStorage.setItem('tsstec.vehicle', JSON.stringify(vehicle)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('tsstec:vehicle:changed', { detail: vehicle }));
    }
    var fitBase = (window.tsstec && window.tsstec.fitmentCollectionUrl) || '/collections/passende-teile';
    window.location.href = fitBase + '?filter.p.m.custom.fits_vehicles=' + encodeURIComponent(gid);
  }

  /* ---- Suche: Marken filtern (Step 1) ---- */
  var searchInput = drawer.querySelector('[data-bd-search]');
  var popularSection = drawer.querySelector('[data-bd-popular]');
  var noResult = drawer.querySelector('[data-bd-noresult]');
  var chips = Array.prototype.slice.call(drawer.querySelectorAll('.bd-chip'));
  var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-bd-row]'));

  function filterBrands(q) {
    q = (q || '').trim().toLowerCase();
    if (!q) {
      chips.forEach(function (c) { c.hidden = false; });
      rows.forEach(function (r) { r.hidden = false; });
      if (popularSection) popularSection.hidden = false;
      if (noResult) noResult.hidden = true;
      return;
    }
    var anyChip = false;
    chips.forEach(function (c) {
      var hit = (c.dataset.bdName || '').indexOf(q) !== -1;
      c.hidden = !hit;
      if (hit) anyChip = true;
    });
    if (popularSection) popularSection.hidden = !anyChip;
    var anyRow = false;
    rows.forEach(function (r) {
      var hit = (r.dataset.bdName || '').indexOf(q) !== -1;
      r.hidden = !hit;
      if (hit) anyRow = true;
    });
    if (noResult) noResult.hidden = anyRow || anyChip;
  }
  if (searchInput) {
    searchInput.addEventListener('input', function () { filterBrands(searchInput.value); });
  }

  /* ---- In <body> verschieben (Stacking-Context) ---- */
  var movedToBody = false;
  function ensureInBody() {
    if (movedToBody) return;
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    movedToBody = true;
  }
  function open(instant) {
    ensureInBody();
    document.body.classList.add('brand-drawer-open');
    if (instant) {
      drawer.classList.add('brand-drawer--no-anim');
      drawer.hidden = false;
      drawer.classList.add('is-open');
      if (panel) panel.focus();
      requestAnimationFrame(function () { drawer.classList.remove('brand-drawer--no-anim'); });
    } else {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (panel) panel.focus();
      });
    }
    showStep('brands');
    selected = { brand: null, brandSlug: null, brandLogoSrc: null, displacement: null, model: null };
    if (searchInput) searchInput.value = '';
    filterBrands('');
  }
  function close(instant) {
    drawer.classList.remove('is-open');
    if (instant) {
      drawer.hidden = true;
      return;
    }
    document.body.classList.remove('brand-drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
  }

  drawer.addEventListener('click', function (e) {
    var pickBrandEl = e.target.closest('[data-pick-brand]');
    if (pickBrandEl) {
      var label = pickBrandEl.dataset.pickBrand;
      var img = pickBrandEl.querySelector('img');
      pickBrand(label, img ? img.src : null);
      return;
    }
    var pickEl = e.target.closest('[data-pick]');
    if (pickEl) {
      var step = pickEl.dataset.pick;
      var value = decodeURIComponent(pickEl.dataset.value || '');
      if (step === 'displacement') pickDisplacement(value);
      else if (step === 'model') pickModel(value);
      else if (step === 'year') pickYear(pickEl.dataset.gid);
      return;
    }
    var backEl = e.target.closest('[data-back-to]');
    if (backEl) {
      var to = backEl.dataset.backTo;
      if (to === 'brands') {
        selected = { brand: null, brandSlug: null, brandLogoSrc: null, displacement: null, model: null };
        showStep('brands');
      } else if (to === 'displacement') {
        selected.displacement = null;
        selected.model = null;
        pickBrand(selected.brand, selected.brandLogoSrc);
      } else if (to === 'model') {
        selected.model = null;
        pickDisplacement(selected.displacement);
      }
    }
  });

  opens.forEach(function (b) {
    b.addEventListener('click', function () { open(b.hasAttribute('data-drawer-switch')); });
  });
  closes.forEach(function (b) {
    b.addEventListener('click', function () { close(b.hasAttribute('data-drawer-switch')); });
  });
  drawer.addEventListener('click', function (e) {
    if (drawer.hidden || !panel) return;
    if (panel.contains(e.target)) return;
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('facet-search__input')) return;

    var search = input.closest('.facet-search');
    if (!search) return;
    var container = search.parentElement;
    var query = input.value.trim().toLowerCase();
    var items = container.querySelectorAll('.facets__item');

    items.forEach(function (item) {
      if (query === '') {
        item.style.display = '';
        return;
      }
      var labelEl = item.querySelector('.facet-checkbox__text-label');
      var text = (labelEl ? labelEl.textContent : item.textContent).toLowerCase();
      item.style.display = text.indexOf(query) !== -1 ? '' : 'none';
    });

    var showMore = container.querySelector('show-more-button');
    if (showMore) showMore.style.display = query === '' ? '' : 'none';
  });

  /* ---- Preis-Slider (zwei Griffe) ---- */
  class TsstecPriceSlider extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('.price-slider__range--min');
      this.maxRange = this.querySelector('.price-slider__range--max');
      this.fill = this.querySelector('.price-slider__fill');
      this.max = parseInt(this.dataset.max, 10) || 0;
      if (!this.minRange || !this.maxRange) return;

      var details = this.closest('details');
      var fields = details ? details.querySelectorAll('.field__input') : [];
      this.gte = fields[0];
      this.lte = fields[1];
      this._timer = null;

      this.minRange.addEventListener('input', this.onSlide.bind(this, 'min'));
      this.maxRange.addEventListener('input', this.onSlide.bind(this, 'max'));
      this.paint();

      // Eingabefelder beim Laden mit Min/Max füllen (ohne Filter auszulösen)
      if (this.gte) this.gte.value = parseInt(this.minRange.value, 10);
      if (this.lte) this.lte.value = parseInt(this.maxRange.value, 10);
    }

    onSlide(which) {
      var lo = parseInt(this.minRange.value, 10);
      var hi = parseInt(this.maxRange.value, 10);
      if (lo > hi) {
        if (which === 'min') {
          lo = hi;
          this.minRange.value = lo;
        } else {
          hi = lo;
          this.maxRange.value = hi;
        }
      }
      this.paint();
      this.commit(lo, hi);
    }

    paint() {
      var lo = parseInt(this.minRange.value, 10);
      var hi = parseInt(this.maxRange.value, 10);
      var span = this.max || 1;
      this.fill.style.left = (lo / span) * 100 + '%';
      this.fill.style.right = 100 - (hi / span) * 100 + '%';
      this.minRange.style.zIndex = lo > this.max - lo ? 5 : 4;
    }

    commit(lo, hi) {
      // 1) Sichtbare Eingabefelder SOFORT aktualisieren — reine Anzeige,
      //    löst noch keinen Filter-Request aus.
      if (this.gte) this.gte.value = lo;
      if (this.lte) this.lte.value = hi;

      // 2) Filter-Request gedrosselt feuern, damit das Backend beim Ziehen
      //    nicht mit jedem Pixel-Schritt angefragt wird.
      clearTimeout(this._timer);
      var self = this;
      this._timer = setTimeout(function () {
        if (self.gte) {
          self.gte.dispatchEvent(new Event('input', { bubbles: true }));
          self.gte.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (self.lte) {
          self.lte.dispatchEvent(new Event('input', { bubbles: true }));
          self.lte.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 250);
    }
  }
  if (!customElements.get('tsstec-price-slider')) {
    customElements.define('tsstec-price-slider', TsstecPriceSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-menu-finder]')) return;
    var details = document.getElementById('Details-menu-drawer-container');
    if (details && details.hasAttribute('open')) {
      var summary = details.querySelector('summary');
      if (summary) summary.click();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.getElementById('ProductDrawer');
  if (!drawer) return;
  var panel = drawer.querySelector('.brand-drawer__panel');
  var opens = document.querySelectorAll('[data-product-drawer-open]');
  var closes = drawer.querySelectorAll('[data-product-drawer-close]');

  var movedToBody = false;
  function ensureInBody() {
    if (movedToBody) return;
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    movedToBody = true;
  }
  function open(instant) {
    ensureInBody();
    document.body.classList.add('brand-drawer-open');
    if (instant) {
      drawer.classList.add('brand-drawer--no-anim');
      drawer.hidden = false;
      drawer.classList.add('is-open');
      if (panel) panel.focus();
      requestAnimationFrame(function () { drawer.classList.remove('brand-drawer--no-anim'); });
      return;
    }
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (panel) panel.focus();
    });
  }
  function close(instant) {
    drawer.classList.remove('is-open');
    if (instant) {
      drawer.hidden = true;
      return;
    }
    document.body.classList.remove('brand-drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
  }
  opens.forEach(function (b) {
    b.addEventListener('click', function () { open(b.hasAttribute('data-drawer-switch')); });
  });
  closes.forEach(function (b) {
    b.addEventListener('click', function () { close(b.hasAttribute('data-drawer-switch')); });
  });
  drawer.addEventListener('click', function (e) {
    if (drawer.hidden || !panel) return;
    if (panel.contains(e.target)) return;
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ---- "Weitere Kategorien anzeigen" ---- */
  /* Alle Kategorien stehen dauerhaft in der Liste — kein Aufklappen mehr. */
  var list = drawer.querySelector('[data-pd-list]');
  var rows = list ? Array.prototype.slice.call(list.querySelectorAll('[data-pd-row]')) : [];

  /* ---- Suche / Filter ---- */
  var searchInput = drawer.querySelector('[data-pd-search]');
  var popularSection = drawer.querySelector('[data-pd-popular]');
  var noResult = drawer.querySelector('[data-pd-noresult]');
  var cards = Array.prototype.slice.call(drawer.querySelectorAll('.pd__card'));

  function filter(q) {
    q = (q || '').trim().toLowerCase();
    var anyRow = false;

    if (!q) {
      cards.forEach(function (c) { c.hidden = false; });
      if (popularSection) popularSection.hidden = false;
      rows.forEach(function (r) { r.hidden = false; });
      if (noResult) noResult.hidden = true;
      return;
    }

    // Beliebte-Karten filtern
    var anyCard = false;
    cards.forEach(function (c) {
      var hit = (c.dataset.pdName || '').indexOf(q) !== -1;
      c.hidden = !hit;
      if (hit) anyCard = true;
    });
    if (popularSection) popularSection.hidden = !anyCard;

    // Alle-Kategorien filtern
    rows.forEach(function (r) {
      var hit = (r.dataset.pdName || '').indexOf(q) !== -1;
      r.hidden = !hit;
      if (hit) anyRow = true;
    });
    if (noResult) noResult.hidden = anyRow || anyCard;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () { filter(searchInput.value); });
  }
  // Bei jedem Öffnen Suche zurücksetzen
  opens.forEach(function (b) {
    b.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      filter('');
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tsstec-header-search"] && !Shopify.designMode) return;
  try {
    (function () {
  var toggle = document.querySelector('[data-search-toggle]');
  if (!toggle) return;
  toggle.addEventListener('click', function () {
    var open = document.body.classList.toggle('tsstec-search-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = document.querySelector('.tsstec-header-search__input');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
  });
  // Mit Escape schließen
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('tsstec-search-open')) {
      document.body.classList.remove('tsstec-search-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tsstec-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tsstec-card-carousel')) {
  customElements.define('tsstec-card-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.count = this.dots.length;
      this.index = 0;
      this.url = this.dataset.url || '';
      this._down = null;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.go(i);
        });
      });

      this.addEventListener('pointerdown', (e) => {
        if (e.target.closest('[data-dot]')) return;
        this._down = { x: e.clientX, y: e.clientY };
      });
      this.addEventListener('pointerup', (e) => {
        if (!this._down || e.target.closest('[data-dot]')) { this._down = null; return; }
        const dx = e.clientX - this._down.x;
        const dy = e.clientY - this._down.y;
        this._down = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          this.go(this.index + (dx < 0 ? 1 : -1));
        } else if (Math.abs(dx) < 8 && Math.abs(dy) < 8 && this.url) {
          window.location.href = this.url;
        }
      });
    }

    go(i) {
      if (this.count < 2) return;
      this.index = (i + this.count) % this.count;
      if (this.track) {
        this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
      }
      this.dots.forEach((dot, di) => dot.classList.toggle('is-active', di === this.index));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
